import styled from 'styled-components'

export const SeeInstallmentContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 16px;
`

export const SeeInstallmentLink = styled.a`
  display: flex;
  width: 100%;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #2e2d37;
  border: 1px solid #2e2d37;

  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;

  &:hover {
    cursor: pointer;
  }
`
